﻿/**
* DevExpress Dashboard (_date-filter-item-properties-composer.js)
* Version:  20.1.8
* Build date: Oct 12, 2020
* Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var index_internal_1 = require("../../../data/index.internal");
var index_metadata_1 = require("../../../model/index.metadata");
var _object_properties_wrapper_1 = require("../../form-adapter/_object-properties-wrapper");
var _accordion_tab_1 = require("../../properties-controller/_accordion-tab");
var _base_properties_composer_1 = require("./_base-properties-composer");
var _shared_composers_1 = require("./_shared-composers");
var DateFilterItemPropertiesComposer = (function (_super) {
    __extends(DateFilterItemPropertiesComposer, _super);
    function DateFilterItemPropertiesComposer(customizeHandler, editRuleHandler) {
        var _this = _super.call(this, customizeHandler) || this;
        _this.editRuleHandler = editRuleHandler;
        return _this;
    }
    DateFilterItemPropertiesComposer.prototype._composeTabsCore = function (model, args) {
        return [
            new _accordion_tab_1.AccordionTab(_accordion_tab_1.KnownTabs.Common, 'DashboardWebStringId.AccordionTab.Common', _shared_composers_1.SharedComposers.getCommonWrapper(model, [], {})),
            new _accordion_tab_1.AccordionTab(_accordion_tab_1.KnownTabs.Layout, 'Layout', this.getLayoutWrapper(model)),
            new _accordion_tab_1.AccordionTab(_accordion_tab_1.KnownTabs.CustomRanges, 'DashboardWebStringId.RangeFilter.CustomPeriods', _shared_composers_1.SharedComposers.getCustomRangesWrapper(model, this.editRuleHandler, args.dataSourceBrowser, model.dimension))
        ];
    };
    DateFilterItemPropertiesComposer.prototype.getLayoutWrapper = function (model) {
        var properties = [
            index_metadata_1.filterType,
            index_metadata_1.arrangementMode,
            index_metadata_1.datePickerLocation,
            index_metadata_1.displayTextPattern
        ];
        index_metadata_1.displayTextPattern.editorOptions['placeholder'] = index_internal_1.getLocalizationById(index_metadata_1.displayTextPattern.editorOptions['placeholder']);
        return new _object_properties_wrapper_1.ObjectPropertiesWrapper({
            model: model,
            properties: properties
        });
    };
    return DateFilterItemPropertiesComposer;
}(_base_properties_composer_1.DashboardItemPropertiesComposer));
exports.DateFilterItemPropertiesComposer = DateFilterItemPropertiesComposer;
